export default __webpack_public_path__ + "static/media/tree-map-icon.a114ada3.svg";